<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link to="/help" class="vx-row">
            <feather-icon icon="ArrowLeft" svgClasses="text-dark" />
            <h3>Back</h3>
          </router-link>
        </li>
      </ul>
    </div>
    <!-- <router-link to="/help" class="vx-row"> </router-link>
    <h3>Create Support Ticket</h3> -->
    <div class="chart-container">
      <h3>Create Support Ticket</h3>
      <vs-col :lg="12">
        <vs-row>
          <vs-col :lg="5">
            <p>Category</p>
            <v-select
              label="mCodeValue"
              :options="ticketTemplates.problemsDatas"
              placeholder="Select Category"
              :reduce="mCodeValue => mCodeValue.id"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="ticket.problemCode"
              @input="getSubCategory"
            >
              <template v-slot:option="option">{{
                option.mCodeValue
              }}</template>
            </v-select>
          </vs-col>

          <vs-col :lg="1"></vs-col>
          <vs-col :lg="5">
            <p>Sub Category</p>
            <v-select
              label="subCategory"
              :options="subCategoryItem"
              placeholder="Select Sub Category"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="ticket.subCategory"
              :reduce="id => id.id"
              class="min-w-200 w-full mb-2"
            />
          </vs-col>
        </vs-row>
      </vs-col>
      <vs-col :lg="12">
        <vs-row>
          <vs-col :lg="5">
            <p>Type</p>
            <v-select
              label="teamDescription"
              :options="ticketTeamMappingData"
              placeholder="--Select One--"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="ticket.type"
              class="min-w-200 w-full mb-2"
            />
            <template v-slot:option="option">
              {{ option.teamDescription }}
            </template>

            <!-- <vs-select label="Label" class="drop"> </vs-select> -->
          </vs-col>
          <vs-col :lg="1"></vs-col>
          <vs-col :lg="5">
            <div class="center content-inputs">
              <p>Description</p>
              <textarea
                class="right-width"
                v-model="ticket.description"
                style="height:35px;border:1px solid #D5D4DC"
              />
            </div>
          </vs-col>
        </vs-row>
      </vs-col>
      <vs-col :lg="12">
        <vs-row>
          <vs-col :lg="5">
            <p>File</p>
            <input type="file" id="file" multiple @change="changeDocument" />
          </vs-col>

          <vs-col :lg="1"></vs-col>
          <!-- <vs-col :lg="5">
            <p>Source</p>
            <v-select
              label="mCodeValue"
              :options="sourceData"
              placeholder="--Select Sourse--"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-model="ticket.assignedTo"
              :reduce="mCodeValue => mCodeValue.userId"
              class="texts"
            />
           
          </vs-col> -->
        </vs-row>
      </vs-col>
      <vs-col :lg="12">
        <vs-row>
          <!-- <vs-col :lg="5">
            <p>Due Time</p>
            <input
              placeholder="Enter Subject"
              v-model="ticket.dueTime"
              class="left-width"
              style="height:35px;border:1px solid #D5D4DC"
            />
          </vs-col> -->
          <vs-col :lg="1"></vs-col>
          <!-- <vs-col :lg="5">
            <p>Title</p>
            <input
              placeholder="Enter Subject"
              v-model="ticket.title"
              class="right-width"
              style="height:35px;border:1px solid #D5D4DC"
            />
          </vs-col> -->
        </vs-row>
      </vs-col>
      <vs-col :lg="12">
        <vs-row>
          <vs-col :lg="5">
            <!-- <div class="center con-selects">
              <p>Ticket Date</p>
              <input
                placeholder="Enter Email"
                v-model="ticket.ticketDate"
                class="left-width"
                style="height:35px;border:1px solid #D5D4DC"
              />
            </div> -->
          </vs-col>
          <vs-col :lg="1"></vs-col>
          <!-- <vs-col :lg="5">
            <div class="center content-inputs">
              <p>Description</p>
              <input
                placeholder="Enter Email"
                v-model="ticket.description"
                class="right-width"
                style="height:35px;border:1px solid #D5D4DC"
              />
            </div>
          </vs-col> -->
        </vs-row>
      </vs-col>

      <div class="button_content">
        <vs-button class="create_utton1" @click="">
          Cancel
        </vs-button>
        <vs-button class="create_utton2" @click="updateTicket">
          Save
        </vs-button>
      </div>
    </div>
  </div>
</template>
<script>
import { getTicketSubCategory, getTicketList } from "@/services/dashboard";
import moment from "moment";
import vSelect from "vue-select";
import { mapState } from "vuex";
import { setHeader, removeHeader } from "@/services";
const ticketObj = {
  dueTime: null,
  assignedTo: null,
  priority: null,
  sourceOfTicket: null,
  problemCode: null,
  subCategory: null,
  description: null,
  type: null,
  status: "",
  title: "",
  locale: "en",
  dateFormat: "dd MMMM yyyy",
  ticketDate: moment().format("DD MMMM YYYY"),
  ticketURL: "https://smartway.trigital.in/app/#/viewTicket/10",
  ticketURL2: "https://ngb.trigital.in/NGB_Client/app/#/viewTicket/",
  ticketTime: null
};
export default {
  props: ["clientId", "refresh"],
  data() {
    return {
      ticketId: "",
      ticketCreatePopup: false,
      cancelTicketPopup: false,
      ticket: { ...ticketObj },
      ticketTeamMappingData: ["Service", "Subscripton", "Bill"],
      bulkUploads: {
        file: null
      },
      ticketPopup: false,
      configdateTimePicker: {
        enableTime: true,
        dateFormat: "d-m-Y H:i"
      },
      subCategoryItem: [],
      teamUsersItem: [{ id: null, username: "all" }],
      cancelObj: {
        status: "",
        resolutionDescription: "",
        ticketURL: "https://ngb.trigital.in/NGB_Client/app/#/viewTicket/"
      },
      CtemplateData: {}
    };
  },
  components: {
    "v-select": vSelect
  },
  computed: {
    userInfo() {
      return this.$store.getters["auth/getUser"];
    },
    ticketList() {
      return this.$store.getters["dashboard/getTicketList"];
    },
    ticketTemplates() {
      return this.$store.getters["dashboard/getTicketTemplate"];
    },
    template() {
      return this.$store.getters["dashboard/getTicketTemplate"];
    },
    ...mapState({
      subCategoryItem: state => state.entity.ticketSubcategory,
      teamUsers: state => state.dashboard.teamUsers,
      ticketById: state => state.dashboard.ticketById,
      ticketViewById: state => state.dashboard.ticketViewById
    })
  },

  methods: {
    getDate(date) {
      if (date) return moment(date.join("/")).format("DD MMMM YYYY");
      return null;
    },
    async getTickets() {
      try {
        const response = await getTicketList(this.userInfo.clientId);
        this.$store.dispatch("dashboard/getTicketList", response.data);
      } catch (error) {
        console.log(
          "something went to wrong while retrieving client tickets:",
          error
        );
      }
    },
    async getSubCategory(categoryId) {
      try {
        const response = await getTicketSubCategory(categoryId);
        this.subCategoryItem = response.data.subCategory;
      } catch (e) {
        console.log(e);
      }
    },

    async ticketTemplate() {
      try {
        await this.$store.dispatch("dashboard/setTicketTemplate");
        this.getTicketById();
      } catch (error) {
        console.log(
          "something went to wrong while retrieving client tickets:",
          error
        );
      }
    },
    async getTicketById() {
      try {
        await this.$store.dispatch("dashboard/setTicketById", {
          clientId: this.clientId,
          id: this.ticketId
        });
        await this.getSubCategory(this.ticketById.problemCode);
        await this.$store.dispatch(
          "dashboard/getUserByTeam",
          this.ticketById.teamId
        );
        this.ticket.assignedTo = this.ticketById.teamUserId;
        this.ticket.priority = this.ticketById.priority;
        this.ticket.problemCode = this.ticketById.problemCode;
        this.ticket.subCategory = this.ticketById.subCategoryes;
        this.ticket.status = this.ticketById.status;
        this.ticket.description = this.ticketById.lastComment;
        this.ticket.sourceOfTicket = this.ticketById.sourceOfTicket;
        this.ticket.teamCode = this.ticketById.teamId;

        this.refresh = false;
      } catch (e) {}
    },
    changeDocument(e) {
      this.bulkUploads.file = document.getElementById("file").files[0];
    },
    async updateTicket() {
      let formData = new FormData();
      setHeader("Content-Type", "multipart/form-data");
      formData.append("type", this.ticket.type);
      formData.append("description", this.ticket.description);
      formData.append("file", this.bulkUploads.file);
      formData.append("category", this.ticket.problemCode);
      formData.append("subcategory", this.ticket.subCategory);
      removeHeader("Content-Type");
      try {
        await this.$store.dispatch("dashboard/updateTicketTemplate", {
          clientId: this.userInfo.clientId,
          data: formData
        });
        this.$router.push(`/help`);
        //this.getTickets();
      } catch (e) {
        console.log(e);
      }
    }
  },
  mounted() {
    this.ticketTemplate();
  },
  watch: {
    ticketCreatePopup(newValue) {
      if (newValue) {
        this.ticketTemplate();
        this.ticket.ticketDate = moment().format("DD MMMM YYYY hh:mm:ss a");
      }
    },
    "ticket.problemCode"(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getSubCategory(this.ticket.problemCode);
      }
    },
    "ticket.teamCode"(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.getTeamUsers(this.ticket.teamCode);
      }
    },
    "ticket.dueTime"(newValue, oldValue) {
      debugger;
    },
    ticketPopup(newval) {
      if (newval) {
        this.ticketTemplate();
      }
    },
    refresh(val) {
      this.getTickets();
    }
  }
};
</script>

<style>
.chart-container {
  background: #fff;
  padding: 20px;
  margin: 0 1rem;
  border-radius: 20px;
}
.invoice-card {
  background: linear-gradient(135deg, #6572bb 0%, #2b3674 100%);
  width: 100%;
  padding: 20px;
  color: #ffffff;
  border-radius: 16px;
}
.button_content {
  display: flex;
  justify-content: space-evenly;
}
.create_utton1 {
  width: 200px;
  background-color: #fff;
  color: red;
  border: 1px solid red;
  font-weight: bold;
  height: 40px;
  margin-left: 140px;
  margin-top: 50px;
}
.create_utton2 {
  width: 200px;
  background-color: #30a852;
  font-weight: bold;
  height: 40px;
  color: #fff;
  border: 1px solid #30a852;
  border-radius: 5px;
  margin-right: 140px;
  margin-top: 50px;
}
.right-width {
  width: 420px;
  border-radius: 4px;
}
.left-width {
  width: 420px;
  border-radius: 4px;
}
.drop {
  /* height: 200px; */
  width: 50rem;
}
/* .texts {
  height: 200px;
} */
.v-select {
  width: 420px;
}
/* .vs-input {
  width: 420px;
  height: 38px;
  border-radius: 15px;
  
} */
</style>
